import { themeColors } from './themeColors'
import { createTheme, adaptV4Theme, Theme } from '@mui/material/styles';
import { forEach, merge } from 'lodash'
import themeOptions from './themeOptions'

declare module '@mui/styles/defaultTheme' {
    interface DefaultTheme extends Theme {}
}

function createMatxThemes() {
    let themes: any = {}

    forEach(themeColors, (value, key) => {
        // @ts-ignore
        themes[key] = createTheme(merge({}, themeOptions, value))
    })
    return themes
}
export const themes = createMatxThemes()
